document.addEventListener('DOMContentLoaded', function() {
	// Находим все блоки подписки на странице (на случай, если форма выведена дважды)
	const subscribeBlocks = document.querySelectorAll('.js-subscribe-ajax-block');

	subscribeBlocks.forEach(function(context) {
		const form = context.querySelector('.js-subscribe-form');
		const input = context.querySelector('.js-subscribe-email');
		const msgBox = context.querySelector('.js-subscribe-message');

		if (!form || !input || !msgBox) return;

		form.addEventListener('submit', function(e) {
			e.preventDefault();

			msgBox.innerHTML = 'Отправка...';
			msgBox.style.color = '#333';

			// Извлекаем токен сессии из data-атрибута контейнера
			const sessid = context.getAttribute('data-sessid');

			const honeypotInput = context.querySelector('.js-subscribe-honeypot');
			const formData = new FormData();
			formData.append('email', input.value);
			formData.append('honeypot', honeypotInput ? honeypotInput.value : '')

			fetch('/bitrix/services/main/ajax.php?c=promicom:subscribe&action=subscribe&mode=class', {
				method: 'POST',
				body: formData,
				headers: {
					'X-Bitrix-Csrf-Token': sessid,
					'X-Requested-With': 'XMLHttpRequest'
				}
			})
				.then(response => {
					if (!response.ok) {
						throw new Error('Ошибка сети или сервера');
					}
					return response.json();
				})
				.then(response => {
					if (response.status === 'success' && response.data) {
						const result = response.data;
						msgBox.innerHTML = result.message;

						if (result.status === 'success') {
							msgBox.style.color = 'green';
							form.reset();
						} else {
							msgBox.style.color = 'red';
						}
					} else {
						const errorMsg = response.errors ? response.errors[0].message : 'Произошла ошибка.';
						msgBox.innerHTML = errorMsg;
						msgBox.style.color = 'red';
					}
				})
				.catch(error => {
					msgBox.innerHTML = 'Произошла непредвиденная ошибка соединения.';
					msgBox.style.color = 'red';
					console.error('Fetch error:', error);
				});
		});
	});
});